import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "help-box" }
const _hoisted_2 = { class: "help-box__title" }
const _hoisted_3 = { class: "help-box__entry" }
const _hoisted_4 = { class: "help-box__entry" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "help-box__entry" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = {
  key: 1,
  type: "button",
  class: "help-box__action-link help-box__action-link--select-project",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userIcon = _resolveComponent("userIcon")!
  const _component_iconMail = _resolveComponent("iconMail")!
  const _component_iconContact = _resolveComponent("iconContact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t('mainMenu.help.title')), 1),
    (_ctx.canShowContactInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_userIcon),
            _createElementVNode("span", null, _toDisplayString(_ctx.activeJdeCustomerInfo.jdeCerRepName || _ctx.$t('generic.na')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_iconMail),
            _createElementVNode("a", {
              href: _ctx.activeJdeCustomerInfo.jdeCerRepEmail ? `mailto:${_ctx.activeJdeCustomerInfo.jdeCerRepEmail}` : undefined
            }, _toDisplayString(_ctx.activeJdeCustomerInfo.jdeCerRepEmail || _ctx.$t('generic.na')), 9, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_iconContact),
            _createElementVNode("a", {
              href: 
            _ctx.activeJdeCustomerInfo.jdeCerRepPhoneNumber ? `tel:${_ctx.activeJdeCustomerInfo.jdeCerRepPhoneNumber}` : undefined
          
            }, _toDisplayString(_ctx.activeJdeCustomerInfo.jdeCerRepPhoneNumber || _ctx.$t('generic.na')), 9, _hoisted_7)
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowCompleteOrgContactInfo && _ctx.onShowCompleteOrgContactInfo(...args))),
            class: "help-box__action-link",
            "aria-label": _ctx.$t('mainMenu.help.completeContactInfo')
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('mainMenu.help.completeContactInfo')), 1)
          ], 8, _hoisted_8)
        ], 64))
      : (_openBlock(), _createElementBlock("button", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('mainMenu.help.selectAProjectToSeeContactInfo')), 1)
        ]))
  ]))
}